/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */
var Slider = require('../ui/slider');
var trackingUtils = require('../utils/tracking.utils');
const Dynpack = require('od-apps/app.dynpack');
const {trackClickEvent} = require('od-modules/track_events/track.frontevents.utils');

module.exports = Odigeo.View.extend({
    ignoreModelUpdate: false,
    slider: {},
    histogram: null,
    selectors: {
        sliderContainer: '.accommodationfilters_slider_container',
        averageMsg: '.filter_average',
        histogram: '.filter_by_price_histogram',
    },

    init: function() {
        this.slider = new Slider(this.$cachedSelectors.sliderContainer, {
            range: {
                min: this.model.get('minPercentile'),
                max: this.model.get('maxPercentile'),
            },
            values: [this.model.get('selectedMinPrice'), this.model.get('selectedMaxPrice')],
            formatter: Odigeo._.bind(this.getFormattedSlider, this),
            showValuesInRange: true,
            styleClass: 'od-ui-spaced-slider',
        });
        this.$cachedSelectors.sliderContainer.addClass('build_handler_finished');
        this.histogram = Odigeo.UIElements.histogram(this.$cachedSelectors.histogram, this.widget.options);
        this.listenTo(this.slider, 'slider:change', Odigeo._.debounce(Odigeo._.flowRight(this.userPriceSelection, this.trackChangeEvent), 300));
        this.slider.$container.on('slider:change', trackClickEvent);
        this.listenTo(this.slider, 'slider:move', this.setUpHistogramBars);
        $(window).resize(Odigeo._.debounce(Odigeo._.bind(this.refreshHistogram, this), 300));
        this.$el.on('updateFilterStatus.accommodationfilter', Odigeo._.bind(this.model.updateFilterStatus, this.model));
        this.$el.on('resetFilterStatus.accommodationfilter', Odigeo._.bind(this.cleanPriceFilter, this));
    },

    getFormattedSlider: function(value) {
        return !Odigeo._.isNaN(value) && Odigeo._.isNumber(value) ? this.getValueWithSign(+value.toFixed(0)) : value;
    },

    getValueWithSign: function(value) {
        return this.getSignValue(value) + this.getFormatCurrency(value);
    },

    getFormatCurrency: function(value) {
        return Odigeo._.partial(Odigeo.Utils.formatCurrency, value, Odigeo._.extend({}, Odigeo.Utils.Currency, {decimalPlaces: 0}))();
    },

    getSignValue: function(value) {
        return value === this.model.get('maxPercentile') ? '&#43 ' : '';
    },

    userPriceSelection: function(values) {
        var config = {
            selectedMinPrice: Odigeo._.isEqual(values[0], this.model.get('minPercentile')) ? null : values[0],
            selectedMaxPrice: Odigeo._.isEqual(values[1], this.model.get('maxPercentile')) ? null : values[1],
        };

        this.sendToFather({
            priceFilterModel: [config],
        });
    },

    trackChangeEvent: function(values) {
        var minOrMax = Odigeo._.isEqual(values[0], this.model.get('selectedMinPrice')) ? 'max' : 'min';
        var trackLabel = ['price', 'range', minOrMax].concat(values).join('_');

        trackingUtils.trackEvent('results_filters_hotels', trackLabel);

        return values;
    },

    cleanPriceFilter: function() {
        this.resetView(true);
        this.sendToFather({
            priceFilterModel: [{
                selectedMinPrice: null,
                selectedMaxPrice: null,
            }],
        });
    },

    sendToFather: function(msg) {
        this.$el.trigger('filterHasChanged.accommodationfilter', msg);
    },

    render: function() {
        this.slider.refresh({
            range: {
                min: this.model.get('minPercentile'),
                max: this.model.get('maxPercentile'),
            },
            values: [this.model.get('selectedMinPrice'), this.model.get('selectedMaxPrice')],
        });
        this.histogram.refresh(this.model.get('relativeFrequencies'));
        this.setUpHistogramBars();
        this.$cachedSelectors.averageMsg.html(this.getFormatCurrency(this.model.get('average')));
        this.resetView(this.model.get('isResetRequested'));

        return this;
    },

    setUpHistogramBars: function() {
        var validRange = Odigeo._.map(this.slider.handlers, function(handler) {
            return handler.getPosition();
        });
        var isInValidRange = function(x) {
            return Odigeo._.first(validRange) <= x && x <= Odigeo._.last(validRange);
        };
        var getClass = function($bar) {
            return isInValidRange(parseInt($bar.attr('x'), 10)) ? 'bar' : 'bar-disabled';
        };

        Odigeo._.each(this.$cachedSelectors.histogram.find('rect'), function(bar) {
            var $bar = $(bar);
            $bar.attr('class', getClass($bar));
        });
    },

    reRender: function($page) {
        if (Dynpack.isAccommodationResults($page.attr('id'))) {
            this.render();
        }
    },

    resetView: function(isResetRequested) {
        if (isResetRequested) {
            this.stopListening(Odigeo)
                .listenTo(Odigeo, 'page:afterSwitch', this.reRender);
        }
    },

    refreshHistogram: function() {
        this.histogram.refresh();
        this.setUpHistogramBars();
    },
});
